import { Container } from 'react-bootstrap';
import './assets/css/style.scss';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Article } from '../../../../shared/interfaces';

function Articles() {
  const [articles, setArticles] = useState<Article[]>([]);

  useEffect(() => {
    fetch('https://strapi-production-a706.up.railway.app/api/articles?populate=*&sort=createdAt:desc')
      .then((res) => res.json())
      .then((data) => {
        setArticles(data.data || []);
      })
      .catch((err) => console.error('Failed to fetch articles:', err));
  }, []);

  return (
    <div className="section pagesgrid">
      <Container>
        <div className="section__content">
          <div className="pagesgrid__grid">
            {articles?.map((article, index) => (
              <div className="pagesgrid__grid-item" key={index}>
                <div className="pagesgrid__grid-item-image">
                  <Link to={`/artikull/${article.id}`}>
                    <img
                      src={article.image.url}
                      alt={`article-${index}`}
                    />
                  </Link>
                </div>
                <div className="pagesgrid__grid-item-title">
                  <Link to={`/artikull/${article.id}`}>
                    <span>{article.title}</span>
                  </Link>
                  <p>
                    {article?.description?.length > 300
                      ? article?.description.substring(0, 300) + '...'
                      : article?.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </div>
  );
}

export default Articles;
